import { render, staticRenderFns } from "./CarRentalTable.vue?vue&type=template&id=2dfe95b0"
import script from "./CarRentalTable.vue?vue&type=script&lang=js"
export * from "./CarRentalTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports